import Testimonial from "segments/desktop/core-components/testimonial/testimonial";
import AssetComponent from "components/core/asset/asset-component";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import StatisticComponent from "segments/desktop/tabs/layouts/carousel-tabs/components/tab-content/components/statistic/statistic-component";
import { StyledTabContentComponent } from "./tab-content-component.scss";

const TabContentComponent = ({ testimonial, asset, stats, tabAdvancedConfig, advancedAssetProps }) => (
  <StyledTabContentComponent
    testimonialMaxWidth={tabAdvancedConfig?.testimonialMaxWidth}
    className="tab-content-component"
  >
    <AssetComponent {...asset} {...advancedAssetProps} />
    <div className="content-wrapper">
      <div className="testimonial-wrapper">
        <Testimonial {...testimonial} />
        {testimonial?.button && (
          <SecondaryButton
            isWithArrow={true}
            color={testimonial.button?.color}
            url={testimonial.button?.buttonUrl}
            buttonText={testimonial.button?.buttonText}
            isOpenLinkInNewTab
          />
        )}
      </div>
      <div className="stats-section">
        {stats?.map((statics, index) => (
          <StatisticComponent
            key={index}
            advancedStaticsConfig={tabAdvancedConfig?.advancedStatsConfig}
            statics={statics}
          />
        ))}
      </div>
    </div>
  </StyledTabContentComponent>
);

export default TabContentComponent;
